<template>
    <layout-card :isCustomizable="settings.isCustomizable"
        :loading="loading"
        :type="settings.context"
        @edit-card="toggleSettingsForm"
        :error="error"
        @hide-card="$emit('hide-card', type)"
        @refresh-card="fetchCard(type, {}, true)"
        class="card-invoice_corp"
        >
        <template #title>
            {{ name }}
        </template>

        <template #content>
            <template-kpi-card :data="{'stats': cardData, 'labels': labels}" />
            <portal to="dashboardSettingsForm">
                <card-setting-overlay
                    v-if="showSettingsForm"
                    :formName="settingsFormName"
                    :cardCustomSettings="customSettings"
                    :cardName="type"
                    @fetched="fetchCard"
                    @close-form="toggleSettingsForm"
                    @custom-settings-saved="fetchCard(type, {}, true)"
                />
            </portal>
        </template>
        <template #footer>
            <fiscal-year-footer :fiscalYearTimestamp="fiscalYear"></fiscal-year-footer>
        </template>
    </layout-card>
</template>

<script>
    import LayoutCard from './LayoutCard.vue'
    import FiscalYearFooter from './FiscalYearFooter.vue'
    import TemplateKpiCard from './TemplateKpiCard.vue'
    import CardMixin from './CardMixin.js'
    import InvoiceMixin from './InvoiceMixin.js'
    export default {
        mixins : [CardMixin, InvoiceMixin],
        components: {
            LayoutCard,
            TemplateKpiCard,
            FiscalYearFooter,
        },
    }
</script>